import React from "react";
import JobsTable from "./table/JobsTable"; // new

function TableData() {
  const data = [
    {
      job_id: "JHBN52",

      deadline: "13-03-2022",
      status: "On Going",
    },
    {
      job_id: "JHBN52",

      deadline: "13-03-2022",
      status: "pause",
    },
    {
      job_id: "JHBN52",

      deadline: "13-03-2022",
      status: "Ongoing",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "Job ID",
        accessor: "job_id",
      },

      {
        Header: "Deadline",
        accessor: "deadline",
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  return (
    <div className="mb-4 -mt-2">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-10">
        <div className="-mt-8">
          <JobsTable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
